// App Distribution Configuration
// Controls download links in SMS/email invitations

export type AppStage = 'development' | 'beta' | 'production';

/** Live on the App Store — https://apps.apple.com/us/app/bookapt/id6756637557 */
export const BOOKAPT_IOS_APP_STORE_URL =
  'https://apps.apple.com/us/app/bookapt/id6756637557';

export const BOOKAPT_WEB_APP_URL = 'https://app.bookapt.io';

// App is live on iOS; Android Play Store listing not yet available.
export const CURRENT_STAGE: AppStage = 'production';

export const APP_DISTRIBUTION = {
  development: {
    downloadMessage:
      'View your appointments on iPhone (App Store), web app, or Android when it launches.',
    showDownloadLink: true,
    iosLink: BOOKAPT_IOS_APP_STORE_URL,
    androidLink: '',
    webLink: BOOKAPT_WEB_APP_URL,
  },

  beta: {
    downloadMessage: 'Join BookAPT beta testing!',
    showDownloadLink: true,
    iosLink: BOOKAPT_IOS_APP_STORE_URL,
    androidLink: '',
    webLink: BOOKAPT_WEB_APP_URL,
  },

  production: {
    downloadMessage:
      'View your appointments on iPhone (App Store), web app, or Android when it launches.',
    showDownloadLink: true,
    iosLink: BOOKAPT_IOS_APP_STORE_URL,
    androidLink: '',
    webLink: BOOKAPT_WEB_APP_URL,
  },
};

/**
 * Get current download links based on stage
 */
export const getDownloadLinks = () => {
  return APP_DISTRIBUTION[CURRENT_STAGE];
};

/**
 * Generate download message for SMS/Email
 */
export const getDownloadMessage = (referralCode?: string): string => {
  const config = APP_DISTRIBUTION[CURRENT_STAGE];

  const webLinkWithRef = referralCode
    ? `${config.webLink}?ref=${referralCode}`
    : config.webLink;

  return `${config.downloadMessage}

📱 iPhone (App Store): ${config.iosLink}
🌐 Web app: ${webLinkWithRef}
🤖 Android: Coming soon`;
};

/**
 * Get smart link (redirects based on device)
 */
export const getSmartDownloadLink = (referralCode?: string): string => {
  const config = APP_DISTRIBUTION[CURRENT_STAGE];
  const baseUrl = config.webLink;

  return referralCode ? `${baseUrl}?ref=${referralCode}` : baseUrl;
};

/**
 * Check if app is publicly available
 */
export const isAppAvailable = (): boolean => {
  return CURRENT_STAGE !== 'development';
};

export default APP_DISTRIBUTION;
